
import { computed, defineComponent, watch } from 'vue'
import store, { MutationName } from '@/store'

enum ToastDuration {
  DEFAULT = 3000,
}

export default defineComponent({
  name: 'Toast',
  setup() {
    let timer: any = null
    const toast = computed(() => store.state.toast)
    const onClick = () => {
      clearTimeout(timer)
      store.commit(MutationName.SET_TOAST, { show: false })
    }
    const isDarkTheme = computed(() => store.state[MutationName.IS_DARK_TOAST])

    watch(toast, (toast: any) => {
      if (!toast.show) {
        return
      }
      timer = setTimeout(() => {
        store.commit(MutationName.SET_TOAST, { show: false })
      }, ToastDuration.DEFAULT)
    })

    return {
      toast,
      onClick,
      isDarkTheme,
    }
  },
})
